import React from 'react';

const Projects = () => {
  return (
    <section id="projects" className="section section-alt">
      <div className="container">
        <h2>Projects</h2>
        <p className="section-subtitle">
          These are examples of small applications you can host on your VPS or
          cloud hosting using your own domain.
        </p>

        <div className="grid">
          <article className="card">
            <h3>Sample Counter App (Live Demo)</h3>
            <p>
              A minimal front-end application that demonstrates a simple counter with
              increment, decrement, and reset actions. Included directly in this portfolio
              as a live widget.
            </p>
            <a href="#live-demo" className="card-link">
              See live demo ↓
            </a>
          </article>

          <article className="card">
            <h3>My API Monitor</h3>
            <p>
              A small dashboard that pings backend APIs and shows their status.
              Deployed on my VPS under <code>apis.pavant.dev</code>.
            </p>
            <a
              href="https://apis.pavant.dev"
              target="_blank"
              rel="noopener noreferrer"
              className="card-link"
            >
              Visit live app
            </a>
          </article>

          <article className="card">
            <h3>Expense Tracker</h3>
            <p>
              A simple CRUD expense tracker built with a preferred stack (e.g., React + Spring Boot).
              This card links to an Expense Tracker hosted app.
            </p>
            <a
              href="https://expense.pavant.dev"
              target="_blank"
              rel="noopener noreferrer"
              className="card-link"
            >
              Visit live app
            </a>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Projects;
